<button mat-icon-button (click)="openDialog()" *ngIf="!usuarioCliente">
  <mat-icon *ngIf="notificaciones.length == 0" >notifications</mat-icon>
  <mat-icon *ngIf="notificaciones.length > 0" matTooltip="Ver notificaciones" color="accent">notifications_active</mat-icon>
</button>
